import { AppContext } from "@lightspeed-invoicing/core-client/frontend/index"
import { HttpError, isError } from "../../../helpers/Error"
import SearchService from "../../../search/SearchService"
import { ImportStockDto, ImportStockDtoAttributes } from "../models"
import { ImportItemsResult, ImportListingSearchPayload } from "./types"

export const OBJECT_TYPE="inventory-import-product"
export class Service {
    static transformIntoSearchPayload(payload: ImportListingSearchPayload) {
        const { filters: availableFilters, fields } = SearchService.getTotalsFiltersAndFields({
            typeOfSearch: OBJECT_TYPE
        })
        
        const transformedPayload = SearchService.getSearchPostData(
            payload.filters, 
            OBJECT_TYPE, 
            availableFilters, 
            undefined, 
            [OBJECT_TYPE], 
            [], 
            fields, 
            payload.keywords
        )
        transformedPayload.filters = { ...transformedPayload.filters}
       
        return {
            ...payload,
            ...transformedPayload,
        }
    }

    static async post(postData : ImportStockDtoAttributes): Promise<ImportStockDtoAttributes[] | HttpError> { 
        const res = await AppContext.getApiClient().post("/inventory-import", postData)
        if (isError(res)) {
            return res as HttpError
        }
        return res as ImportStockDtoAttributes[]
    }

    static async postIntegration(integrationKey: string, postData: ImportStockDtoAttributes):Promise<ImportStockDtoAttributes[] | HttpError> { 
        const res = await AppContext.getApiClient().post(`/${integrationKey}/inventory-import`, postData)
        if (isError(res)) {
            return res as HttpError
        }
        return res as ImportStockDtoAttributes[]
    }

    static async get(importId:string): Promise<ImportStockDto | HttpError> { 
        const res = await AppContext.getApiClient().get(`/inventory-import/${importId}`)
        if (isError(res)) {
            return res as HttpError
        }
        return res as ImportStockDto
    }

    static async fetch(payload: ImportListingSearchPayload): Promise<ImportItemsResult> {
        const res = await AppContext.getApiClient().post("/listing/search", this.transformIntoSearchPayload(payload))
        if (res.error) {
            throw new Error(res.error.message)
        } 

        return res as ImportItemsResult
    }


}




// WEBPACK FOOTER //
// ./src/state/inventory/imports/service/service.ts